import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FASCIA_SPECIALTIES, COACHING_SPECIALTIES } from "../data/specialties";
import { fasciaUrl, coachUrl } from "../data/urls";

const pill = "px-4 py-2 rounded-full bg-white border border-[#eee5d6] text-sm text-[#5c554c] hover:border-[#c76d4b] hover:text-[#c76d4b] transition-colors";

const Group = ({ label, items, toUrl, prefix, cityName, testid }) => (
  <div data-testid={testid}>
    <h3 className="font-serif text-xl font-medium text-[#2b2620] mb-4">{label}</h3>
    <div className="flex flex-wrap gap-2">
      {items.map((s) => (
        <Link key={s.slug} to={toUrl(s.slug)} className={pill} data-testid={`${testid}-${s.slug}`}>
          {s.keyword.toLowerCase().startsWith(prefix.toLowerCase()) ? s.keyword.charAt(0).toUpperCase() + s.keyword.slice(1) : `${prefix} ${s.keyword}`} près de {cityName}
        </Link>
      ))}
    </div>
  </div>
);

export default function CityServiceLinks({ cityName }) {
  return (
    <section className="container-tight py-14" data-testid="city-service-links">
      <h2 className="font-serif text-3xl md:text-4xl font-medium text-[#2b2620] tracking-tight mb-8">
        Mes accompagnements à {cityName}
      </h2>
      <div className="space-y-8">
        <Group label={`Fasciathérapie à ${cityName}`} items={FASCIA_SPECIALTIES} toUrl={fasciaUrl} prefix="Fasciathérapie" cityName={cityName} testid="city-links-fascia" />
        <Group label={`Coach sport-santé à domicile à ${cityName}`} items={COACHING_SPECIALTIES} toUrl={coachUrl} prefix="Coach" cityName={cityName} testid="city-links-coach" />
      </div>
      <div className="mt-10 flex flex-wrap gap-4">
        <Link to="/tarifs" className="inline-flex items-center gap-2 text-sm font-medium text-[#c76d4b] hover:gap-3 transition-all" data-testid="city-link-tarifs">
          Voir les tarifs <ArrowRight size={14} />
        </Link>
        <Link to="/contact" className="inline-flex items-center gap-2 text-sm font-medium text-[#c76d4b] hover:gap-3 transition-all" data-testid="city-link-contact">
          Prendre rendez-vous <ArrowRight size={14} />
        </Link>
      </div>
    </section>
  );
}
